export default "__VITE_ASSET__94864397__"